module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e0b5ccb83cc149fdbeaca13a0693b9ed.png";